<!-- Development Tools -->
<app-loader-component></app-loader-component>
<app-hmr-status></app-hmr-status>

<!-- Enhanced Layout Container -->
<div
  class="app-container"
  [class.app-authenticated]="isLoggedIn"
  [class.app-mobile]="mobile"
>
  <!-- PrimeNG Sidebar - Always visible when conditions met -->
  @if (isLoggedIn && showSideBar) {
    <div
      class="enhanced-primeng-sidebar"
      [ngClass]="{
        'sidebar-expanded': isExpanded,
        'sidebar-collapsed': !isExpanded
      }"
    >
      @if (showSideBar) {
        <app-sidebar></app-sidebar>
      }
    </div>
  }

  <!-- Main Content Area -->
  <div
    class="content-wrapper"
    [ngClass]="{
      'content-authenticated': isLoggedIn,
      'content-admin': isRoleAdmin && isLoggedIn,
      'content-expanded': isExpanded,
      'content-mobile': mobile,
      'content-with-sidebar': isLoggedIn && showSideBar
    }"
  >
    <!-- Enhanced Header -->
    @if (isLoggedIn) {
      <app-navbar class="enhanced-navbar" (sidenav)="toggleSidebar()">
      </app-navbar>
    }

    <!-- Main Content -->
    <main
      class="main-content"
      [ngClass]="{
        'main-authenticated': isLoggedIn,
        'main-with-sidebar': showSideBar && isLoggedIn
      }"
    >
      <!-- Enhanced Breadcrumb -->
      @if (isLoggedIn && showSideBar) {
        <app-breadcrumb class="enhanced-breadcrumb"> </app-breadcrumb>
      }

      <!-- Page Content -->
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>

<!-- Session Expired Modal -->
<app-confirmation-popup
  [image]="'assets/images/shared/warning.svg'"
  [isVisible]="showConfirmModal()"
  [title]="'Session Expired'"
  [description]="'Your session has expired due to inactivity. Please click OK to return to the login page.'"
  [modalWidth]="'sm'"
  [confirmTitle]="'Ok'"
  [cancelTitle]="''"
  (close)="handleModalClose()"
>
</app-confirmation-popup>
